/* tslint:disable */
/* eslint-disable */
export { BasicDocumentType } from '../enums/basic-document-type'